import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-fetch';
import { HeadingText } from '@paypalcorp/pp-react';
import CategoryToolTile from './CategoryToolTile';
import BannerTile from './BannerTile';
import { AMPLITUDE } from '../../../lib/constants';

const RecommendedRow = props => {
  const {
    content = {},
    fptiClick,
    fptiImpression,
    toolTileProps,
    largeTile = true,
    categoryPageLink = ''
  } = props;

  const {
    flatPSData: {
      categories = {},
      isNewLayoutEligible,
      isRecommendedCategoryEligible,
      recommended = []
    }
  } = toolTileProps;

  const isLoggedIn = toolTileProps.app?.context?.user?.isLoggedIn;

  let { featured = [] } = props;

  useEffect(() => {
    fptiImpression({
      amplitude: true,
      event_name: AMPLITUDE.RECOMMENDATION_CATEGORY_VIEW,
      category: categoryPageLink,
      pageLink: categoryPageLink
    });
  }, []);

  const handleClickTool = ({
    fptiLink,
    prod,
    PSUrl,
    categoryRank,
    appKey,
    rank,
    priorityScore
  }) => {
    return () => {
      fptiClick({
        fptiLink,
        prod,
        pageLink: categoryPageLink || content.categoryFPTI,
        amplitude: true,
        event_name: AMPLITUDE.RECOMMENDATION_TILE_CLICK,
        category: categoryPageLink,
        categoryRank,
        appKey,
        rank,
        priorityScore
      });
      fetch(PSUrl);
    };
  };

  const shouldDisplayQuiz =
    isLoggedIn &&
    largeTile &&
    isRecommendedCategoryEligible &&
    recommended[0].isCategoryDisable &&
    recommended[0].isCategoryDisable !== 'TRUE';

  if (!largeTile) {
    featured = featured.slice(0, 6);
  } else if (isNewLayoutEligible) {
    featured = featured.slice(0, shouldDisplayQuiz ? 2 : 3);
  }

  featured = featured.map(tool => {
    const { categoryKey = '' } = tool;
    const loc = categories[categoryKey] ? categories[categoryKey].location : '';
    return {
      ...tool,
      categoryLocation: loc
    };
  });

  return (
    <div
      className={
        isNewLayoutEligible ? 'appcenter-category new' : 'appcenter-category'
      }
    >
      <div
        className={
          isNewLayoutEligible ? 'category-header new' : 'category-header'
        }
      >
        <HeadingText level={2}>{content.categoryTitle}</HeadingText>
      </div>
      <div
        className={
          isNewLayoutEligible
            ? 'category-grid singleton featured-grid'
            : 'category-row'
        }
      >
        {featured.map((tool, index) => (
          <CategoryToolTile
            key={`category-row-tool-${index}`}
            handleClickTool={handleClickTool}
            tool={tool}
            path={`/businesstools/${tool.categoryLocation}`}
            fptiImpression={fptiImpression}
            toolTileProps={toolTileProps}
            pageLink={content.categoryFPTI}
            largeTile={largeTile}
          />
        ))}

        {shouldDisplayQuiz && isNewLayoutEligible && (
          <BannerTile
            content={recommended[0]}
            fptiClick={fptiClick}
            fptiImpression={fptiImpression}
            largeTile={largeTile}
          />
        )}
      </div>
    </div>
  );
};

RecommendedRow.propTypes = {
  featured: PropTypes.array,
  content: PropTypes.object,
  fptiClick: PropTypes.func,
  viewAllText: PropTypes.string,
  fptiImpression: PropTypes.func,
  toolTileProps: PropTypes.object,
  largeTile: PropTypes.bool,
  categoryPageLink: PropTypes.string
};

export default RecommendedRow;
